import { NSARouterMakerResult } from "namirasoft-account-react";
import { Component } from "react";
import { InferenceEntities } from "../InferenceEntities";
import { InferenceInfo } from "../InferenceInfo";
import { InferenceLayout } from '../InferenceLayout';
import { InferenceRouterProps } from "../InferenceRouterProps";

interface ChatListPageProps extends NSARouterMakerResult, InferenceRouterProps { }

export default class ChatListPage extends Component<ChatListPageProps>
{
    override render()
    {
        return (
            <InferenceLayout
                {...this.props}
                action={{ description: InferenceInfo.chat_list }}
                pages={{
                    entity: InferenceEntities.chat(this.props),
                    list: {}
                }}
            >
                <></>
            </InferenceLayout>
        );
    }
}